/**
 * PTO module routes — moved verbatim from router/index.tsx.
 */

import { type RouteObject } from 'react-router-dom';
import { PK } from '@/constants/permissions';
import { ROUTES } from '@/constants';
import { lazyWithRetry } from '@/utils/lazyWithRetry';
import { PermissionRoute } from '../PermissionRoute';

// PTO pages (for Accountant/HeadOfFMO)
const PtoListPage = lazyWithRetry(() => import('@/features/pto/pages/PtoListPage'));
const PtoDetailsPage = lazyWithRetry(() => import('@/features/pto/pages/PtoDetailsPage'));
// `InspectionEditPage.tsx` was deleted in Phase 4 of the inspection redesign; its route
// (`ROUTES.pto.inspectionEdit`) came back 22.09.2026 pointing at `FmoInspectionReviewPage` —
// ФМО's own editor layout, writing through the flow's endpoints. Everyone else (and ФМО, via
// «Открыть пошагово») still gets `ROUTES.applications.mechanicInspection`.
const FmoInspectionReviewPage = lazyWithRetry(() => import('@/features/fmo/pages/FmoInspectionReviewPage'));

export const ptoRoutes: RouteObject[] = [
      // --------------------------------
      // PTO Module (for Accountant/HeadOfFMO)
      // --------------------------------
      {
        path: ROUTES.pto.list,
        element: (
          <PermissionRoute permission={PK.Fmo.PtoView}>
            <PtoListPage />
          </PermissionRoute>
        ),
      },
      {
        path: ROUTES.pto.details,
        element: (
          <PermissionRoute permission={PK.Fmo.PtoView}>
            <PtoDetailsPage />
          </PermissionRoute>
        ),
      },
      {
        path: ROUTES.pto.inspectionEdit,
        element: (
          <PermissionRoute permission={PK.Fmo.PtoVerify}>
            <FmoInspectionReviewPage />
          </PermissionRoute>
        ),
      },
      {
        path: ROUTES.pto.verification,
        element: (
          <PermissionRoute permission={PK.Fmo.PtoVerify}>
            <PtoDetailsPage />
          </PermissionRoute>
        ),
      },
      {
        path: ROUTES.pto.payment,
        element: (
          <PermissionRoute permission={PK.Fmo.PtoUpdatePayment}>
            <PtoDetailsPage />
          </PermissionRoute>
        ),
      },
];
